<template lang="pug">
	.editor-control-input-coords-list(v-if="options")
		.control-coords-drag(v-for="i in options.coordsCount" :key="i")
			label.col-form-label.controls-title(v-if="options.messages?.listLabels?.[i-1]") {{options.messages?.listLabels?.[i-1]}}
			InputCoordsDrag(v-on:change="setValue(i-1, $event)" :default="getCoordsControlDefault(i-1)" :value="getCoordsControlValue(i-1)" :options="getCoordsControlOptions(i-1)")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import InputCoordsDrag					from './../../Editor/Controls/InputCoordsDrag'

	export default {
		name: 'InputCoordsList',
		mixins: [Screen],
		screen: {
			updateOn: [
			],
			events: {
			}
		},
		components: {
			InputCoordsDrag
		},
		props: ["default", "value", "options"],
		data() {

			return {
				showed: true
			};

		},
		mounted() {

		},
		methods: {
			collectData() {

				//console.log('collectData this.default', this.default, this.value, this.options);

			},
			getCoordsControlDefault(i) {

				return this.default[i];

			},
			getCoordsControlValue(i) {

				return this.value ? this.value[i] : this.default[i];

			},
			getCoordsControlOptions(i) {

				return {
					changes: this.options.changes,
					control: this.options.control,
					controlOptions: this.options.controlOptions,
					inputWidth: this.options.inputWidth,
					messages: {
						labels: this.options.messages?.labels?.[i],
						dragProcess: this.options.messages?.dragProcess
					}
				}

			},
			setValue(i, coords) {

				let value = _.cloneDeep(this.value || this.default);
				value[i] = coords;

				this.$emit('change', value);

			}
		}
	}
</script>

<style lang="sass">

	.editor-control-input-coords-list
		display: flex
		flex-direction: row
		color: #f3f4f5

		.control-coords-drag
			display: flex
			flex-direction: column
			flex-wrap: nowrap
			align-items: start
			justify-content: left
			margin-left: 30px

		.control-coords-drag:first-child
			margin-left: 0

</style>
